<template>
<div class="right_side">
  <div class="tab">
    <span :class="[{ 'active':currentType == 'slip'},'slip']" @click="handleChange('slip')">{{ $t('newHome.Cicket.BetingSlip')}}</span>
    <span :class="[{ 'active':currentType == 'bet'},'bet']" @click="handleChange('bet')">{{ $t('newHome.Cicket.MyBets')}}</span> 
  </div> 
  <div class="betting-area">
    <slot :currentType="currentType" v-if="currentType == 'slip'"></slot>
    <div class="recording" v-if="currentType == 'bet'">
      <template v-if="mybetList.length > 0">
        <ul class="_ul">
          <li v-for="item in mybetList" :key="item.id">
            <p style="color:#222;font-weight:550">{{ item.matchName }}</p>
            <p>{{ item.marketName }}</p>
            <p>{{item.betName}} @{{ item.confirmOdd }}</p>
            <p>{{ $t('betting.settleType.NumberofBets')}}:  {{ item.betAmount }}</p>
            <div class="status">
              <!-- <span>{{ $t('newHome.Cicket.Matches')}}</span> -->
              <span v-if="item.status == '1'" style="color:#13aef8">{{ $t('betting.settleType.win')}}</span>
              <span v-if="item.status == '99'">{{ $t('betting.settleType.noSettle')}}</span>
              <span v-if="item.status == '0'" style="color:#ff0000">{{ $t('betting.settleType.lose')}}</span>
              <span v-if="item.status == '-1'">{{ $t('betting.settleType.refund')}}</span>
            </div>
          </li>
        </ul>
        <div class="allbet" @click="handleAllbet">{{ $t('betting.settleType.all')}} {{ $t('betting.settleType.Bets')}}</div>
      </template>
      <template v-else>
        <no-data 
        :nodata_ind="'newHome.Cicket.empty_r'" 
        :nodataTow="'newHome.Cicket.empty'" 
        :Top="'40px'"
        :ws="'36px'" 
        :hs="'32px'"></no-data>
      </template>
    </div>
  </div>
  <promptDialog v-bind="$attrs"/>
</div>
</template>
<script>
import promptDialog from './prompt'
import NoData from '../../NoData'
import { commonApi } from "@/common/index";
import { mapState,mapMutations } from 'vuex'
export default {
  components:{ NoData,promptDialog },
  data(){
    return{
      currentType:'slip',
      mybetList:[],
    }
  },
  computed: {
    ...mapState({
      UUID: state => state.UUID,
      isLogin: state => state.isLogin,
    }),
  },
  watch:{
    isLogin:{
      handler(newVal,oldVal){
        if(!newVal){
          this.mybetList = []
          this.currentType = 'slip'
        }
      }
    }
  },
  methods:{
    ...mapMutations(["setshowloginfloat2",]),
    handleChange(type){
      if(this.isLogin){
        this.currentType = type
        if(type == 'bet'){ this.getMyBets(); }
      }else{
        this.setshowloginfloat2(true)
        this.$notify({ title:this.$t('notify.warning'), message:this.$t('newHome.login'), type: "warning",});
      }
    }, 
    handleAllbet(){
      if(this.isLogin) this.$router.push({ path:'/mine/betList'})
      else this.setshowloginfloat2(true)
    },
    getMyBets(){
      commonApi.Cicket.getMyBets({UUID:this.UUID,pageSize:5,}).then(data=> {
        this.mybetList = data.list
      }).catch(err=>{
        this.mybetList = []
      })
    },
  }
}

</script>
<style lang="scss" scoped>
.right_side{
  width:302px;
  font-size: 16px;
  font-family: Roboto-Bold;
  border-radius: 6px;
  overflow: hidden;
  .tab{
	  color: #fff;
    cursor: pointer;
    font-weight: 550;
    background-color: #37573f;
    display: flex;
    span{ 
      // display: inline-block;
      // box-sizing:content-box;
      width:50%;
      padding:15px 0;
      text-align: center;
      border-bottom:2px solid #fff;
      &.active{
        // color: #13aef8;
        color: #bebf01;
        // border-bottom:2px solid #13aef8;
        border-bottom:2px solid #bebf01;
      }
    }
  }
  .betting-area{
    background-color: #37573f;
    font-size: 16px;
    border-radius: 0 0 6px 6px;
    padding-bottom:30px;
    padding-top:19px;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
    .recording{
      font-size: 14px;
      padding:0px 15px 12px;
      min-height:288px;
      color:#fff; 
      ._ul li{
        padding-bottom:15px;
        border:1px solid #f2f2f2;
        border-radius: 6px;
        padding:19px 17px;
        margin-bottom:12px;
        p{ padding-bottom:6px;-webkit-text-stroke:.3px;} 
        .status{ 
          font-size: 14px;
          padding-top:10px;
          color: #fff;
          -webkit-text-stroke:.3px;
        }
      }
      .allbet{
        text-align: center;
        cursor: pointer;
        height:40px;
        color:#fff;
        line-height: 40px;
        margin-bottom:15px;
        background-color: #e2bf87;
        // background-image:url('../img/btn_home_bet_p.png');
        // background-size:100%;
        color:#fff;
        -webkit-text-stroke: .8px;
      }
    }
  }
}
</style> 



// WEBPACK FOOTER //
// src/pages/build902/components/new-home/R-side/mybets.vue